import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FramesActions, MessagesActions, ValidationActions } from '../../../../actions';
import { BoxTitle, ImagePreview } from '../../../PageTemplate';
import { Submit, File, DoubleClickBtn } from '../../../Form';
import { Img } from '../../../../helper';
import './upload.scss';
import { Box } from '../../../PageTemplate';

const {REACT_APP_FRAME_FILE_TYPES, REACT_APP_FRAME_MAX_FILE_SIZE} = process.env;

class Upload extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eventFinised: false,
            eventID: null,
            frames: null,
            file: null,
            fileInput: null,
            deleteFrameOk: false,
            defaultFramePerPage: 8,
            defaultPageSize: { // default page size A4 300dpi
                width: 2480, 
                height: 3508, 
                dpi: 300
            }
        }

        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleUploadSubmit = this.handleUploadSubmit.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const {eventFinised} = props;
        const frames = props.frames.list;
        const eventID = props.events.currentEventID;
        const newState = {};

        if(eventID && eventID !== state.eventID) newState.eventID = eventID; 
        if(eventFinised && eventFinised !== state.eventFinised) newState.eventFinised = eventFinised;

        // if frame deleted
        if(frames && !frames[eventID] && state.frames && state.frames.length > 0 && state.frames[0].eventID === eventID) {
            newState.frames = null;

            // if user upload this frame (now) before delete it
            newState.file = null;
            newState.fileInput = null

            if(state.fileInput) state.fileInput.value = '';
        }

        // only if frames change
        if(frames && JSON.stringify(frames[eventID]) !== JSON.stringify(state.frames)) {
            newState.frames = frames[eventID];
        }

        if(Object.keys(newState).length > 0) return newState;
        return null;
    }

    handleFileChange(event) {
        if(!event || !event.target || !event.target.files || !event.target.files.length > 0 || this.state.eventFinised) return;
        var file = event.target.files[0];

        const {dispatch} = this.props;

        const validType = dispatch(ValidationActions.fileType(file.type, JSON.parse(REACT_APP_FRAME_FILE_TYPES)));
        const validSize = dispatch(ValidationActions.fileSize(file.size, Number(REACT_APP_FRAME_MAX_FILE_SIZE)));

        // if(this.validateFileType(file.type) && this.validateFileSize(file.size)){
        if(validType && validSize) {
            this.setState({file: file, fileInput: event.target}, this.handleUploadSubmit);
            return;
        }

        event.target.value = '';
        return this.setState({file: null});
    }

    handleUploadSubmit(event) {
        if(event) event.preventDefault();
        const {dispatch} = this.props;
        const {file, defaultFramePerPage, eventID, defaultPageSize} = this.state;

        if(!file) {
            dispatch(MessagesActions.pushInfo(`קודם צריך לבחור מסגרת`));
            return;
        }
        
        this.getImageSize(() => {
            const {frames} = this.state; // get update frames
            const data = {
                x: frames[0].size.x,
                y: frames[0].size.y,
                file: file,
                pageWidth: defaultPageSize.width, 
                pageHeight: defaultPageSize.height,
                dpi: defaultPageSize.dpi
            }

            if(defaultFramePerPage && defaultFramePerPage > 0) data.framePerPage = defaultFramePerPage;

            dispatch(FramesActions.uploadFrame(eventID, data));
        });
    }

    getImageSize(cb) {
        const {file, frames} = this.state;

        Img.getXY(file, (x, y) => {
            const frame = frames ? {...frames[0]} : {size: {}};
            frame.size.x = x;
            frame.size.y = y;

            this.setState({frames: [frame]}, () => {
                cb = cb.bind(this);
                cb();
            });
        });
    }

    deleteFrame() {
        const {dispatch, frames} = this.props;
        const currentFrame = this.state.frames[0];

        if(frames.deleteFrameProcess === true || !currentFrame._id || this.state.eventFinised) return;

        if(!this.state.deleteFrameOk) {
            return this.setState({deleteFrameOk: true});
        }

        this.setState({deleteFrameOk: false});
        dispatch(FramesActions.deleteFrame(this.state.eventID, currentFrame._id));
    }

    render() {
        const {frames} = this.state;
        const frame = frames && frames[0];
        const hasFrameUrl = frame && frame.url;
        const allowedFileTypes = "image/" + JSON.parse(REACT_APP_FRAME_FILE_TYPES).join(",image/");
        const requestInProcess = this.props.frames.uploadFrameProcess;
        const deleteInProgress = this.props.frames.deleteFrameProcess;

        return (
            <Box col="1" id="uploadFrameSettings">
                <BoxTitle icon="faImage">
                    מסגרת המגנט
                </BoxTitle>
                <ImagePreview
                    image={hasFrameUrl || ""}
                    text="הוסיפו את מסגרת המגנט"
                />
                <div style={{display: `${hasFrameUrl ? 'block' : 'none'}`}}>
                    <form onSubmit={this.handleUpdateSubmit} className={`${!hasFrameUrl ? 'noFrame': ''}`}>     
                        <div className="inputRow">
                            <DoubleClickBtn
                                className={`deleteFile ${hasFrameUrl ? '' : 'hide'}`}
                                process={deleteInProgress}
                                clicked={this.state.deleteFrameOk}
                                icon="faTrashAlt"
                                textOne="מחיקה"
                                textTwo="בטוח?"
                                onClick={this.deleteFrame.bind(this)}
                            />
                        </div>
                    </form>
                </div>
                <div style={{display: `${hasFrameUrl ? 'none' : 'block'}`}}>
                    <form onSubmit={this.handleUploadSubmit} className={`${!hasFrameUrl ? 'noFrame': ''}`}>
                        <div className="inputRow">
                            <File 
                                name="frame"
                                onChange={this.handleFileChange}
                                accept={allowedFileTypes}
                                placeholder="בחרו מסגרת"
                            />
                            {/* <Submit process={requestInProcess} disabled={hasFrameUrl || this.state.eventFinised} className={`${this.state.file ? 'hasFile' : ''}`} icon="faCloudUploadAlt" text="שמירה"/> */}
                        </div>
                    </form>
                </div>
            </Box>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer,
        frames: state.framesReducer
    }
}

const UploadWithRedux = connect(mapStateToProps)(Upload);

export {UploadWithRedux as Upload};


// WEBPACK FOOTER //
// ./src/components/EventPage/settings/frame/Upload.jsx